import { render, staticRenderFns } from "./Carousel3D.vue?vue&type=template&id=fda4d95c&scoped=true"
import script from "./Carousel3D.vue?vue&type=script&lang=js"
export * from "./Carousel3D.vue?vue&type=script&lang=js"
import style0 from "./Carousel3D.vue?vue&type=style&index=0&id=fda4d95c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fda4d95c",
  null
  
)

export default component.exports